/*******************************************************************
* PAGE        : SkeletonComponent
* REMARKS     : Comman Skeleton Loader Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 24-02-2026
********************************************************************/

const SkeletonComponent = ({ height = "20px", width = "100%" }) => {
    return (
        <div
            style={{
                height,
                width,
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                marginBottom: "8px",
                animation: "pulse 1.5s infinite"
            }}
        />
    );
};

export default SkeletonComponent;
